export default __webpack_public_path__ + "static/media/pdf.2094b459.svg";